/**
 * The password-reset deep link lives on the app's hash, so it works without a
 * router: the email sends `${origin}/#/reset-password?token=…`, and App() parses
 * the token before any auth gate. Pure helpers — unit-tested, no React.
 */

/** Parse the reset token out of the current hash, or null when there is none. */
export function parseResetToken(hash: string): string | null {
  const path = hash.replace(/^#\/?/, '');
  if (!path.startsWith('reset-password')) return null;
  const token = new URLSearchParams(path.split('?')[1] ?? '').get('token');
  return token && token.length > 0 ? token : null;
}

/** The hash to navigate to after a successful reset clears the flow. */
export function clearResetHash(): void {
  window.location.hash = '';
}